import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

interface IProps {
  subscription: Subscription;
  onUpdate: () => void;
  setOpen: (value: boolean) => void;
  setClose: () => void;
  open: boolean;
  loading: boolean;
  containsGift: boolean;
}

export default ({
  open,
  setOpen,
  setClose,
  subscription,
  onUpdate,
  loading,
  containsGift,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={open} onClose={setClose} isCentered>
      <ModalOverlay className="awt-order-now-modal--overlay">
        <ModalContent className="awt-order-now-modal">
          <ModalHeader>{t('subscription.order_now')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text marginBottom={0}>
              {containsGift
                ? t('subscription.order_now_modal_body_gifting')
                : t('subscription.order_now_modal_body', {
                    amount: subscription.FormattedSubscriptionTotal,
                  })}
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button mr="4" onClick={setClose} variant="outlined">
              {t('titles.cancel')}
            </Button>
            <Button isLoading={loading} onClick={onUpdate}>
              {t('titles.confirm')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};
